import { t } from '@lingui/macro';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeCompetitorsParkingsOperatorsFilter } from '../../../ac/onChangeMapFilters';
import { functionalAreasYandexUrentTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { DynamicAttributeFilter } from '../DynamicAttributeFilter';


const CompetitorsParkingsComponent = ({
    mapFilters,
    onChangeCompetitorsParkingsOperatorsFilter,
}) => (
    <div>
        {/* Динамический фильтр операторов — парковки конкурентов */}
        <DynamicAttributeFilter
            title={t`Операторы (парковки)`}
            attributeTypes={functionalAreasYandexUrentTypes}
            availableValues={mapFilters.competitorsParkingsAvailableOperators}
            disabledValues={mapFilters.competitorsParkingsOperatorsDisabled}
            onToggle={onChangeCompetitorsParkingsOperatorsFilter}
            inputNamePrefix="competitors-parkings-operator"
        />
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(
    mapStateToProps,
    { onChangeCompetitorsParkingsOperatorsFilter }
)(CompetitorsParkingsComponent);

export const CompetitorsParkingsFilter = withDisplayedLayersCheck(ConnectedComponent, 'Парковки (конкуренты)');
